import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { APP_BASE_HREF } from '@angular/common';
import {AuthGuard} from './shared/guard/auth.guard';
import {ShouldAuthenticateGuard} from './shared/guard/should-authenticate-guard';

// service config
const SERVICE_CONFIG: any[] = [
  {
    provide: APP_BASE_HREF,
    useValue: '/pharmacy/mdp-dashboard/'
  }
];

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'select-user',
    loadChildren: () => import('./dashboard/select-user/select-user.module').then(m => m.SelectUserModule)
    // canActivate: [AuthGuard]
  },
  {
    path: 'logout',
    loadChildren: () => import('./logout/logout.module').then(m => m.LogoutModule)
  },
  /*signin{
    path: 'signin', // DEV ONLY: MUST REMOVE BEFORE LIVE DEPLOYMENT AS SCAT IS USED
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
    canActivate: [ShouldAuthenticateGuard]
   },signin*/
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [
    RouterModule
  ],
  providers: [...SERVICE_CONFIG]
})

export class AppRoutingModule { }
